<template lang="pug">
div(
    v-if="$geolocation.enabled || $storyblok.isEditing"
    :class="{ 'relative': $storyblok.isEditing }"
)
    div(
        class="flex items-center justify-between cursor-pointer lg:p-0"
        :class="classes"
        data-testid="locationDisplay"
        @click="openLocationPopup"
    )
        div(class="flex items-center text-sm")
            LocationIcon(class="w-4 h-4 mr-1 fill-current")
            span {{ $geolocation.formattedLocation }}

            //- Show some text in Storyblok when geolocation is disabled
            span(v-if="!$geolocation.enabled") Geolocation Disabled

    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )

</template>

<script>
import LocationIcon from '@/assets/common/location?inline'
import { generateFontColorClass } from '../../helpers'

export default {
    name: 'GeoTextWidget',
    components: { LocationIcon },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        classes() {
            return generateFontColorClass(this.data?.textColor)
        },
    },
    methods: {
        openLocationPopup() {
            this.$geolocation.openModal()
        },
    },
}
</script>
